export default __webpack_public_path__ + "images/JK.64516bb.png";